var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.29996C26.2 8.15996 31.84 10.02 37.44 11.91C35.37 14.48 34.14 17.73 34.14 21.28V21.35C28.6 19.48 23.01 17.63 17.43 15.79C11.81 13.93 6.16001 12.07 0.570007 10.18C2.63001 7.60996 3.86001 4.35998 3.86001 0.819977V0.72998C9.40001 2.60998 14.99 4.45996 20.57 6.29996Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad8);
export default __webpack_public_path__ + "static/media/road_8.8cec0be8abdafcf5f0870bf75d94261c.svg";
export { ForwardRef as ReactComponent };